import { DOCUMENT_TYPES } from "@/static/documentTypes";
import { KpContractor } from "@/models/api/Contractor";

export class CashDocumentItemEdit {
  name!: string;
  amountInCurrency!: number;
  documentId!: string | null; //wtf?
  constructor() {
    this.name = "";
    this.amountInCurrency = 0;
    this.documentId = null;
  }
}

export class CashDocumentEdit {
  paymentId!: number | null;
  cashboxId!: number | null;
  issueDate!: string;
  description!: string;
  documentType!: DOCUMENT_TYPES | null;
  amount!: number | null;
  exchangeDate!: string;
  contractor!: KpContractor;
  documentItems!: CashDocumentItemEdit[];
}

export class CreateDocumentCashDocumentModel extends CashDocumentEdit {
  isDialog = true;
  exchangeRate = 0;
}
